export const NFT_FACTORY_BY_CHAIN_ID = {
    1: '0x2089771532F9Ad6a232965800BEaD93FdcFB69fE',
    5: '0x13B1Ac0A294c04327F13053Dddfe76D8F4B0CDfa',
    56: '0x8aFd821C57699B97e7A4B29Bd114Cd44C104Ea88',
    66: '0xBd1a50a1Aa006c3e5C2480404ec6b59092c03f4C',
    97: '0xF849834425921304d831144cFbc37a2a73C7265f',
    109: '0x074aE1D2edAf8Ed8F006fC58C02a069368C61542',
    137: '0xb9a8A5A6b1Dd95841D9c0a9E441D6d545f642f9A',
    196: '0xbB08c00692FeCf06E23A48F043a42689CE6B40a4',
    1116: '0x961B7f60bb2591Ed7FbA70FFC225c0CC51CB85e7',
    4663: '0xc25a86D6984e7Fa9038Ee32Da5688cA7d37726f2',
    8453: '0xb34f4eFe2E2c4532DEF1842DBa66B02091ed247c',
    42161: '0x07E9a76cc1Abd80F658703e2E57A64b4aa46cFc3',
}

export const nftFactoryLookupAbi = [
    'function nftMap(address) view returns (address owner, address addr, uint256 createdAt, uint256 templateId)',
]

export const nftV2Abi = [
    'function templateVersion() view returns (uint256)',
    'function getMintPaymentConfig() view returns (uint256 mode, address token, uint256 price, uint256 configVersion, uint256 createdBlock)',
    'function updateMintPayment(uint256 mode, address token, uint256 price)',
    'function supportsMutableUserMintLimit() view returns (bool)',
    'function updateUserMintLimit(uint256 newLimit)',
    'function mintWithConfigVersion(address inviter, uint256 amount, string value, uint256 expectedConfigVersion) payable',
    'function rewardOfAsset(address inviter, address paymentAsset) view returns (uint256)',
    'function getUsersPage(uint256 offset, uint256 limit) view returns (tuple(uint256 id, address addr, uint256 mintCount, address inviterAddr, uint256 inviterCount, uint256 reward)[] users, uint256 total)',
    'function getInvitedUsersPage(address inviter, uint256 offset, uint256 limit) view returns (tuple(uint256 id, address addr, uint256 mintCount, address inviterAddr, uint256 inviterCount, uint256 reward)[] users, uint256 total)',
]
